import React, { Component } from 'react';
import { Row, Col, HeadingText } from '@paypalcorp/pp-react';
import styles from './hubFeaturedCharityContainer.less';
import SelectedFeaturedCharity from '../selectFeaturedCharity/selectFeaturedCharity';
import HubCharityCard from '../hubFeaturedCharityCard/hubCharityCard';
import * as analytics from '../../lib/analytics';

export default class FeaturedCharityContainer extends Component {
  constructor(props) {
    super(props);
    let showSelectedCharity = props.selectedCharityIndexOnRedirect !== -1;
    this.state = {
      selectedCharity: showSelectedCharity,
      selectedIndex: props.selectedCharityIndexOnRedirect,
      showFeaturedCharities: !showSelectedCharity,
      preferredCharityNpid: this.props.preferredCharityNpid,
    };
  }

  handleCharityClick(charity, index) {
    this.setState({
      selectedCharity: true,
      selectedIndex: index,
      showFeaturedCharities: false,
    });
    this.handleAnalyticsClick(charity, 'charity');
  }

  handleAnalyticsClick(charity, linkname) {
    analytics.trackLinkWithData(
      linkname,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { crid: charity.nonprofit_id },
      'link'
    );
  }

  handleBackNavigation() {
    this.setState({
      selectedCharity: false,
      showFeaturedCharities: true,
    });
  }

  handleSetFavCharityChange(charity) {
    if (charity.nonprofit_id !== this.state.preferredCharityNpid) {
      this.setState({
        preferredCharityNpid: charity.nonprofit_id,
      });
    } else {
      this.setState({
        preferredCharityNpid: null,
      });
    }
  }

  renderCharities(charities) {
    if (this.state.selectedCharity && !this.state.showFeaturedCharities) {
      const charity = charities[this.state.selectedIndex];
      return (
        <SelectedFeaturedCharity
          charity={charity}
          isCountrySetPreferredSupported={
            this.props.isCountrySetPreferredSupported
          }
          preferredCharityNpid={this.state.preferredCharityNpid}
          unifiedLoginURL={this.props.unifiedLoginURL}
          authState={this.props.authState}
          handleSetFavCharityChange={() =>
            this.handleSetFavCharityChange(charity)
          }
          handleInfoClick={() => this.handleAnalyticsClick(charity, 'infoIcon')}
          userType={this.props.userType}
          npoBaseUrl={this.props.npoBaseUrl}
          i18n={this.props.i18n}
          amounts={this.props.amounts}
          csrf={this.props.csrf}
          handleBackNavigation={() => this.handleBackNavigation()}
          coBrand={this.props.coBrand}
          charityContent={charity.charityContent}
          enable={true}
          fptiInfo={this.props.fptiInfo}
          selectedIndex={this.state.selectedIndex}
          cdnHost={this.props.cdnHost}
        />
      );
    } else {
      return this.renderCharityCards(charities);
    }
  }

  renderCharityCards(charities) {
    const centerAlignStyle =
      charities.length < 4 ? 'ppvx_justify-content-center' : '';
    const charityCards = charities.map((charity, index) => {
      return (
        <Col
          lg={'3'}
          md={'4'}
          sm={'6'}
          xs={'12'}
          className={styles.featuredCharityCardStyle}
          key={index}
        >
          <HubCharityCard
            charity={charity}
            isMobile={this.props.isMobile}
            causeArea={charity.cause_area}
            testId={index}
            viewCharity={() => this.handleCharityClick(charity, index)}
            handleLearnMoreClick={() =>
              this.handleAnalyticsClick(charity, 'learnMore')
            }
            i18n={this.props.i18n}
            enable={this.props.enable}
            fptiInfo={this.props.fptiInfo}
            name={charity.name}
            npid={charity.nonprofit_id}
            logo_url={charity.logo_url}
          />
        </Col>
      );
    });
    return (
      <div>
        <HeadingText as='h3' size='sm' className={styles.featuredModuleHeader}>
          {this.props.i18n('label.charity-module-title')}
        </HeadingText>
        <Row className={centerAlignStyle} align='left'>
          {charityCards}
        </Row>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className={styles.featuredCharityDisplay}>
          <div className={styles.charityTileRow}>
            {this.renderCharities(this.props.featuredCharities)}
          </div>
        </div>
      </div>
    );
  }
}
